import { render, staticRenderFns } from "./league-match-manage.vue?vue&type=template&id=4305150a&"
import script from "./league-match-manage.vue?vue&type=script&lang=js&"
export * from "./league-match-manage.vue?vue&type=script&lang=js&"
import style0 from "./league-match-manage.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "league-match-manage.vue"
export default component.exports